module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('enter')
      }]
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "dense": "",
      "light": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v("Выберите")]) : _vm._e(), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-actions-btn', {
    attrs: {
      "caption": _vm.sourceActionsCaption(),
      "actions": _vm.sourceActions()
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.sourceIs('LOCAL')) ? _c('div', [_c('v-people-selector-tab', {
    attrs: {
      "query": _vm.request,
      "radio": _vm.radio,
      "fullscreen": _vm.fullscreen,
      "selected": _vm.cxt.selected(),
      "methodsQueue": _vm.methodsQueue
    },
    on: {
      "input": _vm.changeSelected,
      "change": _vm.changeRequest
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sourceIs('SEARCH')) ? _c('div', [_c('v-human-selector-tab', {
    attrs: {
      "query": _vm.request,
      "queryCxt": _vm.queryCxt,
      "radio": _vm.radio,
      "fullscreen": _vm.fullscreen,
      "selected": _vm.cxt.selected(),
      "methodsQueue": _vm.methodsQueue
    },
    on: {
      "input": _vm.changeSelected
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": _vm.cxt.selectedCount() === 0
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.selectedCount() === 0 && !_vm.radio),
      expression: "cxt.selectedCount() === 0 && !radio"
    }],
    on: {
      "click": function($event) {
        return _vm.checkAll()
      }
    }
  }, [_vm._v("Выбрать все")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.selectedCount() > 0),
      expression: "cxt.selectedCount() > 0"
    }],
    on: {
      "click": function($event) {
        return _vm.cxt.clear()
      }
    }
  }, [_vm._v("Очистить")]), _vm._v(" "), _c('span', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function($event) {
        return _vm.firstFocus()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be0db20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/IndividualSelector.vue
// module id = 902
// module chunks = 1